var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:{ active: _vm.active },on:{"click":_vm.input}},[_c('div',{staticClass:"wrapper"},[_vm._t("default"),(_vm.active)?[(_vm.desc)?_c('Icon',{attrs:{"path":_vm.icons.desc,"type":"mdi","size":_vm.iconSize}}):_c('Icon',{attrs:{"path":_vm.icons.asc,"type":"mdi","size":_vm.iconSize}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }